exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._7Wux17qnb04Afjdvml7su{background:#b3b3b3;font-family:menlo, monospace;padding:20px;font-size:14px;position:relative}\n", ""]);

// Exports
exports.locals = {
	"JSONViewer": "_7Wux17qnb04Afjdvml7su"
};